import { React} from 'react'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Categorys = () => {
    
    const { categorys } = useSelector((state) => state.home);

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 6
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 6
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 4
        },
        mdtablet: {
            breakpoint: { max: 991, min: 464 },
            items: 4
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 3
        },
        smmobile: {
            breakpoint: { max: 640, min: 0 },
            items: 2
        },
        xsmobile: {
            breakpoint: { max: 440, min: 0 },
            items: 1
        }
    }
    return (
        <div className='w-[95%] mx-auto relative py-4'>

            <Carousel
                autoPlay={true}
                infinite={true}
                arrows={true}
                responsive={responsive}
                transitionDuration={500}
            >
                {categorys.map((c, i) => (
                    <Link
                        to={`/products/search?category=${encodeURIComponent(c.name)}`}
                        className='h-[130px] block rounded-3xl mx-3 sm:mx-0'
                        key={i}
                    >
                        <div className='w-full h-full relative overflow-hidden'>
                            <img className='object-cover w-full h-full rounded-3xl ' src={c.image} alt={c.name || "category-image"} />
                            <div className='absolute bottom-0 w-full mx-auto  font-semibold left-0 flex justify-center items-center overflow-hidden'>
                                <span title={c.name} className='py-[12px] px-6 w-full text-center rounded-b-3xl bg-secondary/70 text-white truncate'>{c.name}</span>
                            </div>
                        </div>
                    </Link>
                ))}
            </Carousel>
        </div>
    )
}

export default Categorys